import React, {Component} from 'react';
import WistiaVideoPlayer from '../../../../../../common/media/WistiaVideoPlayer';

class CourseInfo extends Component {

    render() {
        const {course} = this.props;
        const currentCourse = Array.isArray(course) ? course[0] : course;

        return (
            <div className="col-12 col-lg-8 video-hold">
                <WistiaVideoPlayer url={currentCourse.trailer_url}/>
            </div>
        );
    }
}

export default CourseInfo;


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/CourseInfo.js